type HasActiveFlag = { active?: boolean };

const isActiveFlag = (active?: boolean): boolean => active !== false;

export const isChannelActive = <T extends HasActiveFlag>(item: T): boolean =>
    isActiveFlag(item.active);

export const getNextActiveState = (current?: boolean): boolean =>
    !isActiveFlag(current);
